import {useState} from 'react';
import {useMixContext} from '../../context/MixContext';
import Classes from './JoinForm.module.scss';
import Login from '../login-signup-form/login/Login';
import SignUp from '../login-signup-form/signup/SignUp';

const JoinForm = () => {
    const {showLogin, setShowLogin} = useMixContext();
    const [showPasswordLogin, setShowPasswordLogin] = useState(false);
    const handleShowPasswordLogin = (e: any) => {
        e.preventDefault();
        setShowPasswordLogin(!showPasswordLogin);
    }
    return (
        <div className={`${Classes.JoinFormWrap}`}>
            <h2>{showLogin ? 'Create an account' : 'Log in'}</h2>
            <div className={Classes.switchBtn}>
                {showLogin ? (
                    <>Already have an account? <button onClick={() => setShowLogin(false)}>Login</button></>
                ) : (
                    <>New to Gifbuz? <button onClick={() => setShowLogin(true)}>Create an account</button></>
                )}
            </div>

            <div className={`${Classes.socialLinks} d-flex align-items-center`}>
                <a
                    href={`${process.env.REACT_APP_GIFBUZ_API}/social-auth/google/login`}
                    className={'d-flex align-items-center'}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 48 48"
                        width="30px"
                        height="30px"
                    >
                        <path fill="#FFC107"
                              d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"/>
                        <path fill="#FF3D00"
                              d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"/>
                        <path fill="#4CAF50"
                              d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"/>
                        <path fill="#1976D2"
                              d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"/>
                    </svg>
                </a>
                <a
                    href={`${process.env.REACT_APP_GIFBUZ_API}/social-auth/facebook/login`}
                    className={'d-flex align-items-center'}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="29.371" height="29.211" viewBox="0 0 26.371 26.211">
                        <path
                            d="M26.371,13.186A13.186,13.186,0,1,0,11.125,26.211V17H7.778V13.186h3.348V10.281c0-3.3,1.969-5.13,4.98-5.13a20.278,20.278,0,0,1,2.952.258V8.653H17.395a1.906,1.906,0,0,0-2.149,2.059v2.473H18.9L18.318,17H15.246v9.214A13.189,13.189,0,0,0,26.371,13.186Z"
                            fill="#fff"
                        />
                    </svg>
                </a>
                <a
                    href={`${process.env.REACT_APP_GIFBUZ_API}/social-auth/twitter/login`}
                    className={'d-flex align-items-center'}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="29.885" height="25.211" viewBox="0 0 24.885 20.211">
                        <path
                            d="M22.327,8.418c.016.221.016.442.016.663A14.411,14.411,0,0,1,7.832,23.592,14.412,14.412,0,0,1,0,21.3a10.552,10.552,0,0,0,1.232.063,10.214,10.214,0,0,0,6.332-2.179,5.109,5.109,0,0,1-4.769-3.537,6.431,6.431,0,0,0,.963.079A5.394,5.394,0,0,0,5.1,15.555a5.1,5.1,0,0,1-4.09-5.005v-.063a5.136,5.136,0,0,0,2.305.647A5.108,5.108,0,0,1,1.737,4.312,14.5,14.5,0,0,0,12.253,9.649a5.757,5.757,0,0,1-.126-1.168,5.1,5.1,0,0,1,8.826-3.49A10.041,10.041,0,0,0,24.19,3.76,5.086,5.086,0,0,1,21.948,6.57a10.224,10.224,0,0,0,2.937-.789A10.963,10.963,0,0,1,22.327,8.418Z"
                            transform="translate(0 -3.381)" fill="#fff"
                        />
                    </svg>
                </a>
            </div>

            <div className={Classes.divider}>
                <span>or</span>
            </div>

            <div className={Classes.LoginSignupFormWrap}>
                {showLogin ?
                    (<SignUp/>) : (<Login
                        showPasswordLogin={showPasswordLogin}
                        handleShowPasswordLogin={handleShowPasswordLogin}
                    />)}
            </div>
        </div>
    );
};

export default JoinForm;